import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

const LocationAutocompleteWrapper = ({ onChange, onClear }) => {
	const [searchText, setSearchText] = useState('');

	const handleSelect = async (address) => {
		setSearchText(address);
		try {
			const results = await geocodeByAddress(address);
			const latLng = await getLatLng(results[0]);
			onChange(latLng); // Pass only lat/lng to form
		} catch (error) {
			console.error('Error during geocoding:', error);
		}
	};

	const handleClear = () => {
		setSearchText('');
		onClear();
	};

	return (
		<PlacesAutocomplete
			value={searchText}
			onChange={(text) => {
				if (text === '') {
					handleClear();
				} else {
					setSearchText(text);
				}
			}}
			onSelect={handleSelect}
		>
			{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
				<div style={{ position: 'relative' }}>
					<Input
						size="large"
						{...getInputProps({
							placeholder: 'Search Places ...',
						})}
						allowClear
						enterButton={false}
					/>
					{suggestions.length > 0 && (
						<div
							className="autocomplete-dropdown-container"
							style={{
								position: 'absolute',
								zIndex: 1000,
								background: '#fff',
								border: '1px solid #ccc',
								width: '100%',
								maxHeight: 200,
								overflowY: 'auto',
							}}
						>
							{loading && <div style={{ padding: 8 }}>Loading...</div>}
							{suggestions.map((suggestion) => {
								const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
								const style = {
									backgroundColor: suggestion.active ? '#fafafa' : '#fff',
									cursor: 'pointer',
									padding: 8,
								};
								return (
									<div
										key={suggestion.placeId}
										{...getSuggestionItemProps(suggestion, {
											className,
											style,
										})}
									>
										<span>{suggestion.description}</span>
									</div>
								);
							})}
						</div>
					)}
				</div>
			)}
		</PlacesAutocomplete>
	);
};

export default LocationAutocompleteWrapper;
